import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { changeDataMyFavoritAmiboAction } from "../Store/actions"
import '../css/Image.css'

export default function CardMyFavorite (props) {
  const {data} = props
  let history = useHistory()
  const dispatch = useDispatch()
  const dataMyFavoritAmibo = useSelector(state => state.myFavoritAmibo.dataMyFavoritAmibo)

  function getDetail () {
    history.push(`/detail/${data.tail}`);
  }

  function removeFavorite () {
    let newFavorite = []
    for (let i = 0; i < dataMyFavoritAmibo.length; i++) {
      if (dataMyFavoritAmibo[i].tail !== data.tail) {
        newFavorite.push(dataMyFavoritAmibo[i])
      }
    }
    dispatch(changeDataMyFavoritAmiboAction(newFavorite))
  }

  if(data) {
    return (
      <div className="col-3" style={{marginBottom: 8}}>
        <div className="card" style={{backgroundColor: "#e4fbff", border: "none"}}>
          <input className="imageLink" type="image" onClick={getDetail} style={{height: 330}} name="Name of image button" src={data.image} alt="Mario" />
          <div className="card-body">
            <h5 className ="card-text">{data.name}</h5>
            <button className="btn" style={{margin: 2, backgroundColor:"#f875aa", borderColor: "#ff9292"}} onClick={removeFavorite}>Remove Favorite</button>
          </div>
        </div>
      </div>
    )
  } 
  else {
    return null
  }
}

